<template>
    <div class="newsletter-preferences-section">
        <patterned-container tag="section">
            <div class="contact-content">
                <transition
                    name="swapin"
                    mode="out-in"
                >
                    <div
                        v-if="!states.success"
                        key="form"
                    >
                        <div class="text-container">
                            <h1 v-test:title>{{ title }}</h1>

                            <markdown-content
                                class="text"
                                :content="text"
                                v-test:text
                            />
                        </div>

                        <newsletter-preferences-form
                            :interests="interests"
                            :submit-button-text="submitButtonText"
                            :contact-data="contactData"
                            :locations="locations"
                            @success="handleFormSuccess"
                        />
                    </div>
                    <div
                        v-else
                        aria-live="polite"
                        key="form-success"
                        ref="success"
                    >
                        <form-success
                            :title="successTitle"
                            :text="successText"
                            @back="states.success = false"
                        />
                    </div>
                </transition>
            </div>
        </patterned-container>
    </div>
</template>

<script>
    import PatternedContainer from '../../molecules/PatternedContainer/PatternedContainer';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import FormSuccess from '../../molecules/FormSuccess/FormSuccess';
    import NewsletterPreferencesForm from '../../molecules/NewsletterPreferencesForm/NewsletterPreferencesForm';

    export default {
        name: 'newsletter-preferences-section',

        components: {
            NewsletterPreferencesForm,
            MarkdownContent,
            PatternedContainer,
            FormSuccess,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            text: {
                type: String,
                required: true,
            },

            interests: {
                type: Array,
                default: () => ([]),
            },

            locations: {
                type: Array,
                default: () => ([]),
            },

            submitButtonText: {
                type: String,
                required: true,
            },

            successTitle: {
                type: String,
                required: true,
            },

            successText: {
                type: String,
                required: true,
            },

            contactData: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                states: {
                    success: false,
                },
            };
        },

        methods: {
            /**
             * Show success message.
             */
            handleFormSuccess() {
                this.states.success = true;
                this.scrollToTop();
            },

            /**
             * Scroll/focus to success message.
             */
            scrollToTop() {
                const el = this.$refs.success;

                if (!el) {
                    return;
                }

                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });

                el.setAttribute('tabIndex', '-1');

                el.focus({
                    preventScroll: true,
                });

                document.activeElement.blur();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .contact-content {
        padding: 50px 0;
        position: relative;

        @include media-breakpoint-up(md) {
            min-height: 600px;
        }
    }

    @keyframes swapIn {
        0% {
            opacity: 0;
            visibility: visible;
        }

        to {
            opacity: 1;
        }
    }

    .swapin-enter-active {
        animation: swapIn 2s;
    }

    .text-container {
        max-width: 660px;
        margin: 0 auto 25px;
        text-align: center;

        @include media-breakpoint-up(md) {
            margin-bottom: 50px;
            font-size: rem(20px);
        }

        ::v-deep {
            p {
                margin-bottom: 1.5em;
            }

            p:last-child {
                margin-bottom: 0;
            }
        }
    }

    .text {
        margin-bottom: 1.5em;
        font-weight: 300;
    }

    .newsletter-preferences-form {
        max-width: 392px;
        margin: 0 auto;
    }
</style>
